<script setup>
import { RouterLink } from "vue-router";
import { useI18n } from "../i18n";
import { useShop } from "../useShop";

const { t } = useI18n();
const { shopConfig } = useShop();
const productViewPath = new URL(shopConfig.value.pageBaseUrl).pathname;
</script>

<template>
  <header>
    <img
      alt="Picmondoo Logo"
      class="logo"
      src="https://picmondo.de/projekte/generator/dist/assets/picmondoo-logo.svg"
      width="50"
      height="50"
    />
    <nav>
      <RouterLink :to="productViewPath">{{ t("productView") }}</RouterLink>
      <RouterLink to="/wandansicht">{{ t("wallView") }}</RouterLink>
    </nav>
  </header>
</template>

<style scoped>
header {
  width: 322pt;
  display: block;
  height: auto;
}
</style>
